const baseURL = 'https://labestia.komerzy.com/';

export default baseURL;
